import { Icon } from "@/components/ds";
import { cn } from "@/lib/utils";

export interface CabeceraGrupoDocumentosProps {
  /** Glifo de Material Symbols — `pending_actions` en lo que falta, `task` en lo cargado. */
  icono: string;
  titulo: string;
  cuenta: number;
  /**
   * `warning` para el grupo de lo que falta (fondo ámbar suave), `neutro` para
   * lo que ya está. El color separa los dos grupos de un vistazo sin que haya
   * que leer el título.
   */
  tono: "warning" | "neutro";
}

/**
 * Cabecera de un grupo de documentos. La comparten Documentación General del
 * trabajador y el panel de documentos de un recurso (EPP / vehículo /
 * maquinaria): las dos separan los documentos en "lo que falta primero, lo que
 * está después", y el encabezado tiene que verse igual en ambas.
 */
export function CabeceraGrupoDocumentos({
  icono,
  titulo,
  cuenta,
  tono,
}: CabeceraGrupoDocumentosProps) {
  return (
    <div
      className={cn(
        "border-border-subtle flex items-center gap-2.5 border-b px-4 py-3",
        tono === "warning" ? "bg-warning-bg" : "bg-surface-muted",
      )}
    >
      <Icon
        name={icono}
        size={17}
        className={tono === "warning" ? "text-warning" : "text-success"}
      />
      <span className="fc-section-title flex-1">{titulo}</span>
      <span
        className={cn("fc-num text-[11.5px]", tono === "warning" ? "text-warning" : "text-soft")}
      >
        {cuenta}
      </span>
    </div>
  );
}
